// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__29oOG","name":"ConsentHeader_name__3aHpf","birthday":"ConsentHeader_birthday__Kkbm6","skeleton":"ConsentHeader_skeleton__3Kx-0"};